var _path, _defs, _radialGradient, _use, _clipPath, _defs2, _radialGradient2, _use2, _clipPath2, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoAmex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 44 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.1.1h43.8v12.7H.1z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M22.8 5.5v-1s-.1-.8-.9-.8h-1.3v1.8h-1.3V.2h3.3s1.7-.2 1.7 1.6c0 .9-.8 1.2-.8 1.2s.7.3.7 1.2v1.3h-1.4m-2.3-3.1h1.4c.4 0 .7-.2.7-.5s-.3-.5-.7-.5h-1.4v1"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 6.151,
    cy: -9.974,
    r: 52.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09b7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#029aca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#0a8ab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#086b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04617f"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible",
    fill: "url(#b)"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M38.7 5.5l-2.1-3.6v3.6h-2.7l-.5-1.1H31l-.5 1.1h-2.1s-1.8-.3-1.8-2.5c0-3 2.1-2.8 2.1-2.9h1.7v1.2H29s-.9 0-1 1.2v.4c0 1.8 1.6 1.2 1.6 1.2l1.7-4h1.9l2 4.8V.2h1.9l2.1 3.5V.2h1.4v5.3h-1.9M31.5 3h1.3l-.6-1.6-.7 1.6"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 6.152,
    cy: -9.975,
    r: 52.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09b7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#029aca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#0a8ab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#086b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04617f"
  }))), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    overflow: "visible",
    fill: "url(#d)"
  })), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M12.2 5.5V1.8l-1.7 3.7H9.4L7.7 1.8v3.7H5l-.5-1.1H2.1l-.5 1.1H.1L2.3.2h1.9l2.1 4.9V.2h2.1l1.5 3.3L11.4.2h2.1v5.3h-1.3M2.6 3H4l-.7-1.6L2.6 3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 6.152,
    cy: -9.974,
    r: 52.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09b7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#029aca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#0a8ab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#086b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04617f"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    overflow: "visible",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    overflow: "visible"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M14.3 5.5V.2h4.2v1.2h-2.9v.8h2.8v1.2h-2.8v.9h2.9v1.2h-4.2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 6.151,
    cy: -9.974,
    r: 52.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09b7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#029aca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#0a8ab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#086b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04617f"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    overflow: "visible",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    overflow: "visible"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M24.7 5.5V.2h1.4v5.3h-1.4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 6.151,
    cy: -9.973,
    r: 52.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09b7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#029aca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#0a8ab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#086b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04617f"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    overflow: "visible",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    overflow: "visible"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M28 12.9v-1s-.1-.8-.9-.8h-1.3v1.8h-1.4V7.5h3.3s1.7-.2 1.7 1.6c0 .9-.8 1.2-.8 1.2s.6.3.6 1.2v1.3H28m-2.3-3h1.4c.4 0 .7-.2.7-.5s-.3-.5-.7-.5h-1.4v1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 6.151,
    cy: -11.621,
    r: 52.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09b7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#029aca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#0a8ab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#086b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04617f"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    overflow: "visible",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M19 12.9h-1.2l-1.4-1.6-1.4 1.6H9.9V7.5h4.9l1.5 1.7 1.6-1.7h4.3s1.7-.2 1.7 1.6c0 1.6-.6 2.1-2.3 2.1h-1.3v1.7H19m-1.7-2.7l1.7 1.9V8.4l-1.7 1.8m-6.1 1.5H14l1.3-1.5L14 8.7h-2.8v.8H14v1.2h-2.8v1m9.1-1.9h1.4c.4 0 .7-.2.7-.5s-.3-.5-.7-.5h-1.4v1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 6.152,
    cy: -11.622,
    r: 52.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09b7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#029aca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#0a8ab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#086b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04617f"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    overflow: "visible",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M37.2 12.8h-2.4v-1.2h2.1s.8.1.8-.4-1.1-.4-1.1-.4-1.9.2-1.9-1.6c0-1.7 1.7-1.6 1.7-1.6H39v1.2h-2.1s-.7-.1-.7.4c0 .4 1 .4 1 .4s2.1-.2 2.1 1.4c0 1.7-1.3 1.9-1.8 1.9-.3 0-.3-.1-.3-.1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 6.151,
    cy: -11.621,
    r: 52.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09b7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#029aca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#0a8ab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#086b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04617f"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    overflow: "visible",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "q",
    d: "M29.9 12.9V7.5h4.3v1.3h-2.9v.8h2.8v1.2h-2.8v.9h2.9v1.2h-4.3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 6.151,
    cy: -11.622,
    r: 52.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09b7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#029aca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#0a8ab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#086b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04617f"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    overflow: "visible",
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M41.9 12.8h-2.4v-1.2h2.1s.8.1.8-.4-1.1-.4-1.1-.4-1.9.2-1.9-1.6c0-1.7 1.7-1.6 1.7-1.6h2.6v1.2h-2.1s-.7-.1-.7.4c0 .4 1 .4 1 .4S44 9.4 44 11c0 1.7-1.3 1.9-1.8 1.9-.2 0-.3-.1-.3-.1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: 6.151,
    cy: -11.621,
    r: 52.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09b7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#029aca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#0a8ab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#086b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04617f"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    overflow: "visible",
    fill: "url(#t)"
  }), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    overflow: "visible"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAmex);
export default __webpack_public_path__ + "dist/media/logo-amex.cdd813148855c015a82709d6140f7268.svg";
export { ForwardRef as ReactComponent };